import { Button, Color, Radius, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { usePermissions } from '@dms/hook'
import { AccessType } from 'zens-store'
import { Link } from 'zens-router'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    padding: Spacing.XXL,
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
  },
  block: {
    marginTop: Spacing.M,
  },
})

interface Props {
  companyId: number
  locationId: number
  onAdd?: () => void
}

const BuildingEmpty = (props: Props) => {
  const { companyId, locationId, onAdd } = props
  const { t } = useTranslation()
  const { hasPermission } = usePermissions(companyId)

  return (
    <View style={styles.container}>
      <Text level={2} style={styles.text}>
        <Trans>There's nothing here yet</Trans>
      </Text>
      {hasPermission(AccessType.Create, 'building') ? (
        <>
          <Text style={[styles.text, styles.block]}>
            <Trans>Add your first building and it will be listed here.</Trans>
          </Text>
          <Link href={`/companies/${companyId}/locations/${locationId}/buildings/add`} asChild>
            <Button
              style={styles.block}
              title={t('Add building')}
              left="plus"
              round
              onPress={onAdd}
              testID="BuildingEmpty.Add"
            />
          </Link>
        </>
      ) : (
        <Text style={[styles.text, styles.block]}>
          <Trans>When a building is added it will be listed here.</Trans>
        </Text>
      )}
    </View>
  )
}

export default BuildingEmpty
